import { p } from '@/utils/content-blocks';
import { POST_HIDE_ONLINE, POST_HIDE_BLUE_TICKS } from './blog-privacy-posts';

/** Blog 首页 7 个分类区块 */
export const BLOG_CATEGORIES = [
	{
		id: 'updates',
		title: 'Latest GB WhatsApp Updates',
		description: 'Version notes, APK changes, and what each build fixes for Android users.',
	},
	{
		id: 'tips',
		title: 'Tips and Tricks',
		description: 'Shortcuts for privacy, media, and daily messaging on modded clients.',
	},
	{
		id: 'howto',
		title: 'How-To Guides',
		description: 'Step-by-step walkthroughs for install, backup, and migration.',
	},
	{
		id: 'security',
		title: 'Security Articles',
		description: 'Ban risk, safe downloads, and how to protect your number.',
	},
	{
		id: 'features',
		title: 'Feature Reviews',
		description: 'Deep dives on themes, privacy toggles, and mod-only tools.',
	},
	{
		id: 'troubleshooting',
		title: 'Troubleshooting Guides',
		description: 'Fix crashes, login loops, and install errors without guesswork.',
	},
	{
		id: 'beginner',
		title: 'Beginner Tutorials',
		description: 'New to GB WhatsApp? Start here before you sideload an APK.',
	},
];

const POST_NOT_WORKING = {
	slug: 'gb-whatsapp-not-working-fix',
	categoryId: 'troubleshooting',
	category: 'Troubleshooting',
	year: '2026',
	readTime: '5 min read',
	datePublished: '2026-01-10',
	dateModified: '2026-05-15',
	dateLabel: 'May 15, 2026',
	title: 'Why Is GB WhatsApp Not Working? Common Fixes',
	h1: 'Why Is GB WhatsApp Not Working? Common Fixes',
	excerpt:
		'GB WhatsApp not working on Android? Learn the most common reasons behind crashes, login problems, verification errors, and update failures with simple fixes that actually work…',
	meta: {
		title: 'Why Is GB WhatsApp Not Working? Common Fixes That Actually Help | GBWaps',
		description:
			'GB WhatsApp not working on Android? Learn the most common reasons behind crashes, login problems, verification errors, and update failures with simple fixes that actually work.',
		keywords: 'gb whatsapp not working, gb whatsapp crash fix, gb whatsapp login problem',
	},
	relatedLink: {
		to: '/troubleshooting/',
		text: 'GB WhatsApp troubleshooting guide',
	},
	sections: [
		{
			id: 'why-stops',
			h2: 'Why GB WhatsApp Suddenly Stops Working',
			blocks: [
				p([
					{
						text: 'Most “GB WhatsApp not working” reports fall into a short list: outdated APK, corrupted install, Android killing the app in the background, or account restrictions from WhatsApp servers. The symptom looks random—one day chats load fine, the next morning you stare at a logo screen—but the fix is usually systematic rather than magical.',
					},
				]),
				p([
					{
						text: 'Before you delete anything, note what changed: did you update Android, install a new mod build, or switch SIM cards? That clue points you to the right section below. Keep a chat backup handy; many fixes are cache-only, but reinstall paths need a restore file ready.',
					},
				]),
			],
		},
		{
			id: 'crashing-after-update',
			h2: 'GB WhatsApp Crashing After Update',
			blocks: [
				p([
					{
						text: 'Crashes right after updating often mean the new APK did not fully replace the old split, or your phone is still running an incompatible architecture build. Install the latest package over the existing app without uninstalling first. If the installer refuses, download again on Wi‑Fi and confirm the file size matches our download page (~82 MB for v18.80).',
					},
				]),
				p([
					{
						text: 'Clear cache only: Settings → Apps → GBWhatsApp → Storage → Clear cache. Avoid “Clear data” until you have a backup. On Xiaomi, Oppo, and Vivo devices, disable battery optimization for GBWhatsApp so the system does not kill the process during startup.',
					},
				]),
			],
		},
		{
			id: 'verification',
			h2: 'Verification Code Not Received Problem',
			blocks: [
				p([
					{
						text: 'SMS verification fails when signal is weak, the country code is wrong, or you request too many codes in one hour. Toggle airplane mode off, double-check the number, and use “Call me” after the first SMS wait. Automatic date and time must be enabled—clock skew breaks the “verifying” spinner even when the code is correct.',
					},
				]),
				p([
					{
						text: 'VPNs and ad-blocking DNS sometimes filter WhatsApp endpoints. Disable them temporarily, switch between Wi‑Fi and mobile data once, then force-stop and reopen GBWhatsApp. Outdated mods fail handshake with servers; update before you blame the carrier.',
					},
				]),
			],
		},
		{
			id: 'stuck-loading',
			h2: 'App Not Opening or Stuck on Loading',
			blocks: [
				p([
					{
						text: 'A frozen splash screen usually means the app cannot read its database or Android blocked storage access. Grant Storage and Contacts permissions, reboot the phone, and open again. If it still hangs, clear cache, then try a same-version reinstall on top of the current install.',
					},
				]),
				p([
					{
						text: 'Low RAM phones may need other heavy apps closed. Check free space—under 500 MB free often causes silent failures during media sync. For a full walkthrough with problem cards, see our ',
					},
					{ link: { to: '/troubleshooting/', text: 'troubleshooting hub' } },
					{ text: '.' },
				]),
			],
		},
		{
			id: 'app-not-installed',
			h2: 'How to Fix "App Not Installed" Error',
			blocks: [
				p([
					{
						text: '“App not installed” during sideload almost always traces to blocked unknown sources, a corrupted download, or another WhatsApp clone with the same package name. Enable Install unknown apps for your browser or Files app, delete the broken APK, re-download, and free at least 500 MB storage.',
					},
				]),
				p([
					{ text: 'Parse errors mean the file truncated—grab a fresh copy from ' },
					{ link: { to: '/download/', text: 'Download GB WhatsApp APK' } },
					{
						text: '. Do not unzip or rename the package. If two mods share one package name, uninstall the conflicting clone before retrying.',
					},
				]),
			],
		},
		{
			id: 'storage-permissions',
			h2: 'Storage and Permission Problems',
			blocks: [
				p([
					{
						text: 'Android 13+ uses granular media permissions. If status download or gallery save fails, open system settings and allow Photos and videos for GBWhatsApp. Backup failures often mean insufficient storage—clear old APKs in Downloads and WhatsApp media you no longer need.',
					},
				]),
				p([
					{
						text: 'Scoped storage changes broke older mod builds. If permissions look correct but media still fails, update to the current 18.80 build rather than fighting an outdated APK.',
					},
				]),
			],
		},
		{
			id: 'when-reinstall',
			h2: 'When You Should Reinstall GB WhatsApp',
			blocks: [
				p([
					{
						text: 'Reinstall when overlay updates fail twice, the app crashes on every launch after cache clear, or you suspect malware from an unknown mirror. Back up to Google Drive or local storage first. Uninstall only if installing over the top does not work—then restore during setup.',
					},
				]),
				p([
					{ text: 'Follow ' },
					{ link: { to: '/install-gbwhatsapp/', text: 'install steps' } },
					{ text: ' after reinstall and verify version 18.80 in About before you re-enable aggressive privacy toggles.' },
				]),
			],
		},
		{
			id: 'final-fix',
			h2: 'Final Fix Recommendations',
			blocks: [
				p([
					{
						text: 'Work in this order: update APK → clear cache → check permissions and storage → test network and clock → reinstall with backup. Skipping straight to uninstall is how people lose years of chats.',
					},
				]),
				p([
					{ text: 'For symptom-specific steps and checklists, open the full ' },
					{ link: { to: '/troubleshooting/', text: 'GB WhatsApp Not Working fix guide' } },
					{ text: ' on GBWaps. Still stuck? Compare answers on the ' },
					{ link: { to: '/faq/', text: 'FAQ page' } },
					{ text: ' before you try random APKs from social media.' },
				]),
			],
		},
	],
};

const POST_BANNED = {
	slug: 'can-you-get-banned-using-gb-whatsapp',
	categoryId: 'security',
	category: 'Security',
	year: '2026',
	readTime: '4 min read',
	datePublished: '2026-02-01',
	dateModified: '2026-05-15',
	dateLabel: 'May 15, 2026',
	title: 'Can You Get Banned for Using GB WhatsApp in 2026?',
	h1: 'Can You Get Banned for Using GB WhatsApp in 2026?',
	excerpt:
		'Many users are worried about WhatsApp bans in 2026. Learn why GB WhatsApp accounts get banned, how anti-ban works, and what users do to reduce ban risk…',
	meta: {
		title: 'Can You Get Banned for Using GB WhatsApp in 2026? | GBWaps',
		description:
			'Many users are worried about WhatsApp bans in 2026. Learn why GB WhatsApp accounts get banned, how anti-ban works, and what users do to reduce ban risk.',
		keywords: 'gb whatsapp ban, gb whatsapp anti ban, is gb whatsapp banned',
	},
	relatedLink: {
		to: '/anti-ban/',
		text: 'GB WhatsApp anti-ban guide',
	},
	sections: [
		{
			id: 'why-bans',
			h2: 'Why WhatsApp Bans GB WhatsApp Users',
			blocks: [
				p([
					{
						text: 'WhatsApp is owned by Meta and only supports official clients distributed through approved channels. GB WhatsApp modifies the client, which can trip automated detection for unauthorized software, spam-like behavior, or mass forwarding. Bans are policy enforcement, not random punishment—but the exact triggers are not fully public.',
					},
				]),
				p([
					{
						text: 'High-risk actions include using very old APKs, blasting links to hundreds of groups, and enabling every privacy hide feature on day one of a new number. Developers add anti-ban patches, yet no mod can promise zero risk.',
					},
				]),
			],
		},
		{
			id: 'temporary-ban',
			h2: 'What Happens After a Temporary Ban',
			blocks: [
				p([
					{
						text: 'A temporary ban shows a countdown timer in the app—often hours to a few days. During that window you cannot send messages. Wait it out without reinstalling repeatedly; aggressive retries sometimes extend the penalty.',
					},
				]),
				p([
					{
						text: 'When the timer ends, open GBWhatsApp gently: update first, send a few normal chats, and avoid bulk broadcasts for a week. Treat it as a warning, not a reset button.',
					},
				]),
			],
		},
		{
			id: 'recover-account',
			h2: 'Can You Recover a Banned Account',
			blocks: [
				p([
					{
						text: 'Permanent bans may block the phone number from WhatsApp entirely. Official appeal paths are limited and not guaranteed. Some users migrate to a new SIM; that is not a “recovery” of the old account—it is a fresh start with new risk if habits do not change.',
					},
				]),
				p([
					{
						text: 'Back up media and export important chats before a ban if you see early warnings (failed login, policy popups). Prevention beats recovery.',
					},
				]),
			],
		},
		{
			id: 'anti-ban-works',
			h2: 'Does Anti-Ban Really Work',
			blocks: [
				p([
					{
						text: 'Anti-ban features adjust how the client identifies itself and may throttle risky actions. They reduce risk for many daily users but are not a warranty. Server-side checks evolve; a build that worked in January may need an update by May.',
					},
				]),
				p([
					{ text: 'Read our detailed ' },
					{ link: { to: '/anti-ban/', text: 'anti-ban guide' } },
					{
						text: ' for settings checklists, forwarding limits, and why you should update promptly when developers ship a new package.',
					},
				]),
			],
		},
		{
			id: 'flagged-signs',
			h2: 'Signs Your Account May Get Flagged',
			blocks: [
				p([
					{
						text: 'Warning signs include repeated “login failed” on a fresh APK, sudden logout on all devices, messages stuck on one gray tick for every contact, or policy-style dialogs mentioning unauthorized clients.',
					},
				]),
				p([
					{
						text: 'If reports spike after you join many groups in one day or use automation plugins, pause broadcasts and update the mod. Third-party “ban remover” apps are scams—avoid them.',
					},
				]),
			],
		},
		{
			id: 'reduce-risk',
			h2: 'How Users Reduce Ban Risk',
			blocks: [
				p([
					{
						text: 'Practical habits: stay on the latest APK, use a secondary number for experiments, avoid mass unknown-contact adds, limit forward chains, and warm up new SIMs with normal chats before heavy marketing use.',
					},
				]),
				p([
					{ text: 'Pair those habits with the ' },
					{ link: { to: '/anti-ban/', text: 'GB WhatsApp anti-ban settings' } },
					{ text: ' page and keep official WhatsApp for work accounts if your employer requires it.' },
				]),
			],
		},
		{
			id: 'worth-using',
			h2: 'Is GB WhatsApp Still Worth Using',
			blocks: [
				p([
					{
						text: 'Millions still use mods for privacy and customization they cannot get in stock WhatsApp. The tradeoff is support: no Meta help desk, manual APK updates, and personal responsibility for ban risk. For many, a secondary number on GBWhatsApp while keeping official WhatsApp for banking and work is the balanced setup.',
					},
				]),
			],
		},
		{
			id: 'final-thoughts',
			h2: 'Final Thoughts',
			blocks: [
				p([
					{
						text: 'You can get banned in 2026—temporary and permanent cases still show up in forums. Treat anti-ban as risk reduction, download only from trusted pages, and never believe “100% safe” marketing.',
					},
				]),
				p([
					{ text: 'Next step: walk through the ' },
					{ link: { to: '/anti-ban/', text: 'full anti-ban guide' } },
					{ text: ' and FAQ ban section before you enable every privacy toggle on a brand-new number.' },
				]),
			],
		},
	],
};

const POST_VS = {
	slug: 'gb-whatsapp-vs-whatsapp',
	categoryId: 'features',
	category: 'Feature Review',
	year: '2026',
	readTime: '4 min read',
	datePublished: '2026-03-01',
	dateModified: '2026-05-15',
	dateLabel: 'May 15, 2026',
	title: "GB WhatsApp vs WhatsApp: What's Actually Different?",
	h1: "GB WhatsApp vs WhatsApp: What's Actually Different?",
	excerpt:
		'Compare GB WhatsApp and official WhatsApp side by side including privacy features, customization, file sharing, safety, and ban risks…',
	meta: {
		title: "GB WhatsApp vs WhatsApp: What's Actually Different? | GBWaps",
		description:
			'Compare GB WhatsApp and official WhatsApp side by side including privacy features, customization, file sharing, safety, and ban risks.',
		keywords: 'gb whatsapp vs whatsapp, gb whatsapp features, whatsapp vs gb whatsapp',
	},
	relatedLink: {
		to: '/features/',
		text: 'GB WhatsApp features list',
	},
	sections: [
		{
			id: 'difference',
			h2: 'What Is the Difference Between GB WhatsApp and WhatsApp',
			blocks: [
				p([
					{
						text: 'Official WhatsApp from Meta is the supported client: Play Store updates, policy compliance, and linked devices within Meta’s rules. GB WhatsApp is a sideloaded mod for Android that adds privacy switches, themes, larger media caps, and power-user tools on top of the same chat network.',
					},
				]),
				p([
					{
						text: 'You still verify with your phone number and message the same contacts—but you maintain the APK yourself, accept ban risk, and skip Google Play auto-updates.',
					},
				]),
			],
		},
		{
			id: 'privacy',
			h2: 'Privacy Features Comparison',
			blocks: [
				p([
					{
						text: 'Stock WhatsApp now offers some privacy controls (last seen, read receipts for limited cases), but GB WhatsApp goes further on many builds: hide online status while chatting, freeze last seen, hide blue ticks selectively, and anti-delete message viewing.',
					},
				]),
				p([
					{
						text: 'Aggressive hiding can look unnatural to contacts and may correlate with reports. Official WhatsApp optimizes for transparent signaling; mods optimize for user control—different philosophies.',
					},
				]),
			],
		},
		{
			id: 'themes',
			h2: 'Custom Themes and UI Changes',
			blocks: [
				p([
					{
						text: 'Official WhatsApp allows basic dark mode and wallpapers. GB WhatsApp supports theme packs, custom fonts, bubble colors, and layout tweaks stock users cannot install without third-party hacks.',
					},
				]),
				p([
					{ text: 'See screenshots and a feature grid on our ' },
					{ link: { to: '/features/', text: 'features page' } },
					{ text: ' for the current v18.80 tool list.' },
				]),
			],
		},
		{
			id: 'file-sharing',
			h2: 'File Sharing and Media Limits',
			blocks: [
				p([
					{
						text: 'Official WhatsApp compresses video and caps document sizes to keep infrastructure predictable. GB WhatsApp often raises limits—handy for HD clips and large PDFs—but receivers on old builds may fail to download your files.',
					},
				]),
				p([
					{
						text: 'Status download and direct gallery save are mod staples; official app restricts saving others’ status by design.',
					},
				]),
			],
		},
		{
			id: 'control',
			h2: 'Which App Gives More Control',
			blocks: [
				p([
					{
						text: 'GB WhatsApp wins on granular control: per-chat locks, scheduled messages on some forks, DND modes, and extended broadcast lists. Official WhatsApp wins on ecosystem integration: Wear OS, regulated business APIs, and predictable policy for enterprises.',
					},
				]),
			],
		},
		{
			id: 'safety',
			h2: 'Safety and Security Differences',
			blocks: [
				p([
					{
						text: 'Official builds receive Play Protect distribution and Meta security response. Mods depend on developer reputation and your download source. Malware disguised as “GB WhatsApp” is common—stick to known sites and scan APKs.',
					},
				]),
				p([
					{
						text: 'End-to-end encryption still applies to messages on the wire, but you trust the mod’s code not to add spyware. That trust decision is on you, not Meta.',
					},
				]),
			],
		},
		{
			id: 'ban-risk',
			h2: 'Ban Risk Comparison',
			blocks: [
				p([
					{
						text: 'Official WhatsApp users face bans mainly for spam or policy abuse, not for client type. GB WhatsApp users add client-detection risk on top of behavior risk. Using both apps on one number simultaneously often fails; many users split personal mod vs work official.',
					},
				]),
				p([
					{ text: 'Explore every mod feature on the ' },
					{ link: { to: '/features/', text: 'GB WhatsApp features list' } },
					{ text: ', then read anti-ban and FAQ before you migrate a business number.' },
				]),
			],
		},
	],
};

export const BLOG_POSTS = sortPostsByDateDesc([
	POST_NOT_WORKING,
	POST_BANNED,
	POST_VS,
	POST_HIDE_ONLINE,
	POST_HIDE_BLUE_TICKS,
]);

export const BLOG_POSTS_BY_SLUG = BLOG_POSTS.reduce((acc, post) => {
	acc[post.slug] = post;
	return acc;
}, {});

/** 按发布日期倒序（新 → 旧） */
export function sortPostsByDateDesc(posts) {
	return [...posts].sort((a, b) => {
		const da = a.datePublished || a.dateModified || '';
		const db = b.datePublished || b.dateModified || '';
		return db.localeCompare(da);
	});
}

/** 发布月份展示，如 May 2026 */
export function formatPublishedMonth(post) {
	const iso = post && (post.datePublished || post.dateModified);
	if (!iso) return post && post.year ? String(post.year) : '';
	const parts = String(iso).split('-');
	if (parts.length < 2) return String(iso);
	const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	const monthIdx = Number(parts[1]) - 1;
	const year = parts[0];
	if (monthIdx < 0 || monthIdx > 11) return year;
	return `${months[monthIdx]} ${year}`;
}

/** 按分类 ID 取文章（Blog 首页分类区，时间倒序） */
export function getPostsByCategory(categoryId) {
	return sortPostsByDateDesc(BLOG_POSTS.filter((post) => post.categoryId === categoryId));
}
